import CourseBadge from '@/micros/edit-project/grid-areas/main/courses/components/icons/course-badge';
import Button from '@ui/buttons/button/button';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import InputWithOverlay from '@ui/input-with-overlay/input-with-overlay';
import Popover from '@ui/popover/popover';
import Text from '@ui/text/text/text';
import { useState } from 'react';

type Props = {
  courseName: string;
  handleSave: (name?: string) => void;
  setShowDeleteCourseModal: (show: boolean) => void;
};
export default function CourseHeader({ courseName, handleSave, setShowDeleteCourseModal }: Props) {
  const [newCourseName, setNewCourseName] = useState(courseName);
  return (
    <div className="flex ai-center jc-center header gap-10">
      <div className="course-badge-container position-relative min-width-40">
        <CourseBadge height={40} width={40} startColor="#5AE4FF" endColor="#A7FF7B" />
        <Icon name={ICONS.TROPHY_FILLED} size={12} color="var(--gray-1200)" />
      </div>
      <InputWithOverlay
        wrapperClass="flex-1 course-name-input"
        data-testid="course-edit-name-input"
        border="solid 1px transparent"
        hoverBackground="var(--gray-900)"
        hoverBorder="solid 1px var(--gray-300)"
        inputProps={{
          value: newCourseName || '',
          placeholder: 'Give your Course a name',
          className: 'radius-4 H2 padding-0',
          onChange: (e) => setNewCourseName(e.target.value),
          onBlur: (e) => handleSave(e.target.value),
        }}
      ></InputWithOverlay>
      <Popover
        icon={ICONS.THREE_DOTS_VERTICAL}
        buttonBgColor="transparent"
        width="fit-content"
        popoverWidth="fit-content"
        forcePosition="bottom-left"
        contentClassName="margin-t-10"
      >
        <Button data-testid="course-edit-delete-btn" onClick={() => setShowDeleteCourseModal(true)}>
          <Text className="L1" color="var(--semantic-red-500)" whiteSpace="nowrap">
            Delete Course
          </Text>
        </Button>
      </Popover>
    </div>
  );
}
